import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import plus from "../../assets/images/Icon feather-plus.png";

import sabadLog from "../../assets/images/logo-sabadi.png";
import { TbBasket } from "react-icons/tb";
export default function SinglePartitionNew({
  value,
  index,
  setProduct,
  type,
  shouldCloseModal = true,
}) {
  const weight = (from_weight, to_weight) => {
    let from =
      from_weight > 1000 ? (
        <span className="">{from_weight / 1000}کیلوگرم</span>
      ) : (
        <span className="">{from_weight}گرم</span>
      );
    let to =
      to_weight > 1000 ? (
        <span className=""> {to_weight / 1000}کیلوگرم </span>
      ) : (
        <span className=""> {to_weight}گرم </span>
      );

    if (value.info.weight_from != "0" && value.info.weight_to != "0") {
      return (
        <div>
          ({from} تا {to})
        </div>
      );
    } else if (value.info.weight_from != "0") {
      return <div>({from})</div>;
    } else if (value.info.weight_to != "0") {
      return <div>({to})</div>;
    } else {
      return <></>;
    }
  };
  return (
    <a
      className="card product "
      style={{ cursor: "pointer" }}
      key={index}
      onClick={(e) => setProduct(value)}
      data-bs-toggle={shouldCloseModal ? "modal" : ""}
      data-bs-target={shouldCloseModal ? "#singleproduct" : ""}
    >
      <div className="pic position-relative">
        {100 -
          Math.round(
            ((+value.info.price - +value.info.discount) / +value.info.price) *
              100
          ) !=
        "0" ? (
          <span
            className=" text-white px-2 position-absolute box-darsad"
            style={{}}
          >
            %
            {100 -
              Math.round(
                ((+value.info.price - +value.info.discount) /
                  +value.info.price) *
                  100
              )}
          </span>
        ) : (
          ""
        )}
        <div className="img1 mt-3 text-center">
          {value.info.supplier_cover_img ? (
            <img
              className="img-res"
              src={`http://sabadi.tatdemo.ir/${value.info.supplier_cover_img}`}
            />
          ) : (
            <img
              className="img-res"
              src={`http://sabadi.tatdemo.ir/${value.info.product_cover_img}`}
            />
          )}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div className="title text-center mt-3 two-line">
          {value.info.title}
          <div style={{ fontSize: 13 }}>
            {weight(value.info.weight_from, value.info.weight_to)}
          </div>
        </div>
        {type != "supplier" ? (
          <div
            className="d-flex align-items-center justify-content-start mx-2 py-1 px-2 "
            style={{
              border: "1px solid lightgray",
              borderRadius: "7px",
            }}
          >
            {value.supplier_info[0].path ? (
              <img
                src={`http://sabadi.tatdemo.ir/${value.supplier_info[0].path}`}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <img src={sabadLog} style={{ width: "40px", height: "40px" }} />
            )}

            <h6 className="fs-12 mt-1 px-2">{value.supplier_info[0].title}</h6>
          </div>
        ) : (
          ""
        )}
        <div
          style={{
            width: "80%",
            height: "2px",
            backgroundColor: "black",
            margin: "5px 25px",
          }}
        ></div>
        <div className="d-flex justify-content-around w-100 ">
          <div>
            {100 -
              Math.round(
                ((+value.info.price - +value.info.discount) /
                  +value.info.price) *
                  100
              ) !=
            "0" ? (
              <div
                className="cost"
                style={{
                  textDecoration: "line-through",
                  color: "black",
                  fontSize: "17px",
                }}
              >
                {addCommas(value.info.price)}ت
              </div>
            ) : (
              ""
            )}
            {100 -
              Math.round(
                ((+value.info.price - +value.info.discount) /
                  +value.info.price) *
                  100
              ) !=
            "0" ? (
              <div
                className="cost"
                style={{ color: "#ff4734", fontWeight: "bold" }}
              >
                {addCommas(value.info.price - value.info.discount)}ت
              </div>
            ) : (
              <div
                className="cost"
                style={{
                  color: "#ff4734",
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                {addCommas(value.info.price - value.info.discount)}ت
              </div>
            )}
          </div>
          <div>
            <button className="btn-basket">
              <TbBasket></TbBasket>
            </button>
          </div>
        </div>
      </div>
    </a>
  );
}
